module.exports = new __parcel__URL__("chtilug.adb3777e.png").toString();